import React from "react";
import { Link } from "react-router-dom";
import { createPageStyles } from "./MarketingPageStyles";

const styles = createPageStyles("light", "dailysign");

const copy = {
  crumb: "매일수어 Terms",
  title: "매일수어,",
  accentTitle: "이용약관",
  subtitle:
    "최종 업데이트일: 2026년 9월 3일. 본 서비스의 운영 주체는 Daydream Factory입니다. 매일수어 앱과 관련 웹페이지를 이용하는 경우 아래 약관이 적용됩니다.",
  sections: [
    {
      title: "1. 서비스 소개",
      body:
        "매일수어는 별도의 회원가입 없이 사용할 수 있는 한국수어(KSL) 학습 앱입니다. 학습 진도, 스트릭, 즐겨찾기 등 이용 기록은 모두 사용자 기기 안에 저장됩니다.",
    },
    {
      title: "2. 광고와 전체 잠금해제 구매",
      list: [
        "매일수어는 무료로 시작할 수 있으며, 무료 이용 구간에는 광고(Google AdMob)가 표시될 수 있습니다.",
        "전체 커리큘럼 잠금해제는 구독이 아닌 일회성 구매로 제공되며, 가격은 결제 화면 및 스토어에 표시된 내용을 따릅니다.",
        "보상형 광고 시청을 통해 일부 콘텐츠를 잠금해제할 수 있는 기능이 제공될 수 있습니다.",
        "구매 내역은 같은 스토어 계정에서 '구매 복원' 기능으로 복원할 수 있습니다.",
        "결제·환불은 Apple App Store 및 Google Play 정책에 따릅니다.",
      ],
    },
    {
      title: "3. 콘텐츠 출처와 이용",
      list: [
        "수어 단어·영상은 국립국어원 「한국수어사전」 공공데이터(공공누리 제1유형)를 활용했습니다. 본 앱은 국립국어원과 무관한 독립 서비스입니다.",
        "수어 표현은 지역·상황·화자에 따라 다를 수 있으며, 앱의 콘텐츠는 학습 참고용입니다.",
        "영상 재생을 위해 국립국어원 미디어 서버에 접속하며, 네트워크 환경에 따라 재생이 지연되거나 제한될 수 있습니다.",
      ],
    },
    {
      title: "4. 따라하기(카메라) 기능",
      body:
        "따라하기 기능의 카메라는 화면 미리보기 전용입니다. 영상을 촬영·저장·전송하지 않으며, 카메라 권한을 거부해도 나머지 기능은 정상적으로 사용할 수 있습니다.",
    },
    {
      title: "5. 데이터와 사용자 책임",
      list: [
        "학습 기록은 기기 로컬에 저장되며, Daydream Factory는 해당 내용에 접근하지 않습니다.",
        "기기 교체·앱 삭제 시 데이터가 사라질 수 있으므로, 중요한 기록은 사용자가 별도로 관리할 책임이 있습니다.",
      ],
    },
    {
      title: "6. 면책",
      list: [
        "매일수어는 '있는 그대로' 제공되며, 광고·결제·외부 미디어 서버 등 외부 서비스 상태에 따라 일부 기능이 지연되거나 제한될 수 있습니다.",
        "본 서비스 이용 또는 데이터 유실로 발생한 손해에 대해 관련 법령이 허용하는 범위 내에서 책임이 제한될 수 있습니다.",
      ],
    },
    {
      title: "7. 지적재산권",
      body:
        "매일수어 앱과 디자인, 로고에 대한 권리는 Daydream Factory에 있으며, 무단 복제·배포·역설계를 금지합니다. 수어 영상 콘텐츠의 권리는 원 저작권자(국립국어원)의 공공누리 조건을 따릅니다.",
    },
    {
      title: "8. 약관 변경",
      body:
        "본 약관은 서비스 개선 또는 법령 변경에 따라 수정될 수 있으며, 중요한 변경은 앱 또는 본 페이지를 통해 안내합니다.",
    },
    {
      title: "9. 문의",
      body: "본 약관에 관한 문의: support@daydreamfactory.net",
    },
  ],
};

const DailySignTerms: React.FC = () => {
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      document.documentElement.lang = "ko";
    }
  }, []);

  return (
    <main style={styles.page}>
      <div style={styles.shell}>
        <div style={styles.topRow}>
          <Link to="/" style={styles.homeLink}>
            ← Daydream Factory
          </Link>
          <span style={styles.crumb}>{copy.crumb}</span>
        </div>

        <section style={styles.hero}>
          <h1 style={styles.title}>
            {copy.title}
            <br />
            <span style={styles.accentTitle}>{copy.accentTitle}</span>
          </h1>
          <p style={styles.subtitle}>{copy.subtitle}</p>
        </section>

        {copy.sections.map((section) => (
          <section key={section.title} style={styles.section}>
            <h2 style={styles.h2}>{section.title}</h2>
            <div style={styles.sectionCard}>
              {section.body ? (
                <p style={styles.body}>
                  {section.body.includes("support@daydreamfactory.net") ? (
                    <>
                      {section.body.replace("support@daydreamfactory.net", "")}
                      <a href="mailto:support@daydreamfactory.net" style={styles.link}>
                        support@daydreamfactory.net
                      </a>
                    </>
                  ) : (
                    section.body
                  )}
                </p>
              ) : null}
              {section.list ? (
                <ul style={styles.list}>
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
};

export default DailySignTerms;
